import React from "react";
import { AiFillYoutube } from "react-icons/ai";
import { v4 as uuidv4 } from "uuid";
import { ControlPanel } from "./ControlPanel";
import { PreviewPlayer } from "./PlayerPreview";
import { PlayerDevice } from "./Player";
import { AddPreview } from "./AddPreview/AddPreview";
export const YoutubeWidget = {
    id: "f33d1439-009e-466e-a02b-279f5256e52f",
    name: "Youtube",
    icon: React.createElement(AiFillYoutube, { color: "red" }),
    type: "youtube",
    inHeadbar: true,
    description: "Add weather informations (current weather, hourly, daily)",
    keywords: ["vidéos", "videos", "youtube"],
    config: null,
    createdAt: "2022-07-18T08:03:18.585Z",
    updatedAt: "2022-07-18T08:03:18.585Z",
    isActive: true,
    isDeleted: false,
    load: null,
    scope: ["font"],
    controlPanel: ControlPanel,
    playerPreview: PreviewPlayer,
    context: null,
    playerDevice: PlayerDevice,
    contextDevice: ({ children }) => React.createElement(React.Fragment, null, children),
    addWidgetPreview: [AddPreview],
    height: "auto",
    resize: {
        bottom: false,
        bottomLeft: true,
        bottomRight: true,
        left: false,
        right: false,
        top: false,
        topLeft: true,
        topRight: true,
    },
    factory: () => ({
        id: uuidv4(),
        data: {
            videoUrl: "",
            displayTitle: false,
            displayQrCode: false,
            titleType: "default",
            customTitle: "Titre personnalisé",
            font: "Montserrat",
            size: 16,
            fontWeight: 400,
            textColor: "#FFFFFF",
            qrCodeSize: 16,
            qrCodeWeight: 400,
            qrCodeFont: "Montserrat",
            qrCodeTextColor: "#FFFFFF",
            qrCodeFgColor: "#FFFFFF",
            qrCodeBgColor: "#333333",
        },
    }),
    scalePlayer: true,
};
